import PropTypes from 'prop-types';
var AppearanceTypes = {
  listing: {
    showSubheadings: false
  },
  watchlist: {
    showSubheadings: false
  },
  agent: {
    showSubheadings: true
  },
  appraisal: {
    showSubheadings: true
  }
};
var appearancePropTypes = PropTypes.oneOf(Object.keys(AppearanceTypes));
var showSubheadings = key => AppearanceTypes[key] ? AppearanceTypes[key].showSubheadings : false;
var isListingAppearance = key => AppearanceTypes[key] === AppearanceTypes.listing;
var isWatchlistAppearance = key => AppearanceTypes[key] === AppearanceTypes.watchlist;
var isAppraisalAppearance = key => AppearanceTypes[key] === AppearanceTypes.appraisal;
export { appearancePropTypes, showSubheadings, isListingAppearance, isWatchlistAppearance, isAppraisalAppearance };